/**
 * Аналитика — заглушка для Фазы 1. Полная реализация (с отправкой на бэк или
 * во внешний сервис) появится в Фазе 3.
 *
 * В Фазе 1 события только логируются в console и складываются в память —
 * это нужно, чтобы при разработке экранов было видно, что событие срабатывает.
 */

import type { AnalyticsEvent, AnalyticsEventName, AnalyticsEventParams } from '@/types/analytics';

const TAG = '[Analytics]';
const buffer: AnalyticsEvent[] = [];

export function trackEvent(name: AnalyticsEventName, params?: AnalyticsEventParams): void {
  const event: AnalyticsEvent = {
    name,
    params,
    timestamp: Date.now(),
  };
  buffer.push(event);
  if (params) {
    console.log(`${TAG} ${name}`, params);
  } else {
    console.log(`${TAG} ${name}`);
  }
}

export function getRecordedEvents(): readonly AnalyticsEvent[] {
  return buffer;
}

export function clearRecordedEvents(): void {
  buffer.length = 0;
}
